<template>
  <div>
    <div class="tgc-mosaicv2-slim-m_flex" v-if="results.length > 0">
      <Article :key="item.id.value" v-for="(item,index) in results" :item="item" :order="index + 1"></Article>
    </div>
    <div class="upml-article-list" v-if="results.length === 0">
      <p>Loading...</p>
    </div>
  </div>
</template>

<script>
import Article from './Article.vue';

export default {
  name: 'ArticleList',
  components: {
    Article
  },
  props: {
    results: Array,
    name: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
h3 {
  margin: 40px 0 0;
}

.upml-article-list {
  display: flex;
  flex-flow: row;
  align-items: flex-start;
  justify-content: center;
  flex: 1 0 25%;
}

.upml-article__heading {
  text-align: left;
  font-family: $fontfamily-title-custom;
  font-weight: bold;
  font-size: 1.2rem;
  line-height: 26px;
  margin: 0;
}
</style>
